<script>
    import Content from "$lib/components/layout/page/Content.svelte";
    import { page } from "$app/stores";
    import Heading from "$components/layout/page/Heading.svelte";
    // Set our active section so our menu can be pretty
    import { activeSection, activeColor } from "$lib/data";
    import { onMount } from "svelte";
    onMount(() => {
        $activeSection = "home";
        $activeColor = 0;
    });
</script>

<svelte:head>
    <title>
        {$page.status} Error - Craft Roulette
    </title>
</svelte:head>
<Content>
    <span slot="title">
        {#if $page.status === 404}
            Not Found
        {:else if $page.status === 500}
            Server Error
        {:else}
            {$page.status}
        {/if}
    </span>
    <span slot="meta">
        {#if $page.status === 404}
            404 - Oops, we can't find the content you were looking for.
        {:else if $page.status === 500}
            500 - Something went wrong on our server.
        {:else}
            {$page.error?.message}
        {/if}
    </span>
    <svelte:fragment slot="content">
        {#if $page.status === 404}
            <p>
                You're seeing this message because the content you're trying to access doesn't exist
                on our server.
            </p>
            <p>Please use the menu to try and find what you are looking for...</p>
            <p>
                If you followed a link and got this error, please <a href="/contact">let us know</a>
                so we can fix it.
            </p>
        {:else if $page.status === 500}
            <p>Don't worry! We can fix this! Follow the instructions below for an immediate fix.</p>
            <Heading>Trying To Submit A Contribution</Heading>
            <p>
                This means your device is out of sync with the server. This is an easy fix, we just
                need to do a "hard refresh."
            </p>
            <div class="key_ground" />
            <div class="key_group">
                <h3>On a Windows Desktop using Chrome, FireFox, or Edge</h3>
                <p>
                    Press these keys together: <kbd>CTRL</kbd> + <kbd>F5</kbd>
                </p>
            </div>
            <div class="key_group">
                <h3>On a Mac Desktop using Chrome, FireFox, or Edge</h3>
                <p>
                    Press these keys together: <kbd>⌘</kbd> + <kbd>Shift</kbd> + <kbd>R</kbd>
                </p>
            </div>
            <div class="key_group">
                <h3>On a Mac Desktop using Safari</h3>
                <p>
                    Press these keys together: <kbd>⌘</kbd> + <kbd>option</kbd> + <kbd>E</kbd>
                </p>
            </div>
            <div class="key_group">
                <h3>On a Phone/Mobile Device</h3>
                <p>
                    The easiest way to do this is to close the tab / browser app showing this page
                    and to manually restart the entire device. Seems a little weird I know but it
                    works :)
                </p>
            </div>
            <Heading>Trying To Login</Heading>
            <p>Same thing as above.</p>
            <Heading>Anything Else</Heading>
            <p>
                Please try the instructions above first, and then <a href="/contact">Contact Us</a> if
                the problem still persists.
            </p>
        {:else}
            {$page.error?.message}
        {/if}
    </svelte:fragment>
</Content>

<style>
.key_group {
  border-bottom: 1px solid var(--dots);
}

kbd {
  margin: 0px 0.1em;
  padding: 0.1em 0.6em;
  border-radius: 3px;
  border: 1px solid rgb(204, 204, 204);
  color: rgb(51, 51, 51);
  line-height: 1.4;
  font-family: Bitter;
  font-size: 1rem;
  display: inline-block;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.2), inset 0px 0px 0px 2px #ffffff;
  background-color: rgb(247, 247, 247);
  -moz-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2), 0 0 0 2px #ffffff inset;
  -webkit-box-shadow: 0 1px 0px rgba(0, 0, 0, 0.2), 0 0 0 2px #ffffff inset;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  text-shadow: 0 1px 0 #fff;
}
</style>
